import React, { useState } from "react";
import axios from "axios";
import { main_api } from "../../api/api";

const SecondPopupTab = ({ title, time, date, centers }) => {
    const comment = centers?.includes("Buzovna")
        ? "Buzovna Parking"
        : "Buzovna Dənizkənarı";

    const [formData, setFormData] = useState({
        name: "",
        car_number: "Kirayə avtomobil", // Устанавливаем значение по умолчанию
        movie: title,
        time,
        date,
        comment,
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name) {
            setResponseMessage("Boşluqları doldurun zəhmət olmasa");
            return;
        }

        try {
            const response = await axios.post(`${main_api}/buyers`, formData);
            setResponseMessage("Məlumatlar göndərildi");
            console.log(response.data);
            setIsFormSubmitted(true);
        } catch (error) {
            console.error(error);
            setResponseMessage("Xəta baş verdi.");
        }
    };

    return (
        <div className="bg-main max-w-lg w-full">
            {isFormSubmitted ? (
                <div className="flex justify-center">
                    <iframe
                        title="Epoint ödəniş widget"
                        src="https://epoint.az/az/widget?id=5676&type=users"
                        frameBorder="0"
                        allowTransparency="true"
                        scrolling="no"
                        width="300"
                        height="140"
                    ></iframe>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Ad Soyad</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-md p-2 outline-none"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Qeydiyyat nişanı (Avtomobil)</label>
                        <input
                            type="text"
                            name="car_number"
                            value={formData.car_number}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-md p-2 outline-none"
                            required
                            maxLength={7}
                            minLength={7}
                            readOnly // Если значение не должно изменяться
                        />
                        {/* <p className="text-[#ff6363]">
                            1 avtomobil üçün bilet, avtomobildə olan izləyici sayı fərq etmir
                        </p> */}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Film</label>
                        <input
                            type="text"
                            name="movie"
                            value={formData.movie}
                            readOnly
                            className="w-full border border-gray-300 rounded-md p-2 outline-none bg-gray-100 cursor-not-allowed"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Saat - Tarix</label>
                        <input
                            type="text"
                            name="time"
                            value={`${formData.time} - ${formData.date}`}
                            readOnly
                            className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed outline-none"
                        />
                    </div>
                    <div>
                    <p className="text-white font-semibold text-center">Ödəniş: 30 azn.</p>
                    </div>
                    {responseMessage && (
                        <p className="text-center text-[#ff6363]">{responseMessage}</p>
                    )}
                    <div className="w-full flex justify-center">
                        <button
                            type="submit"
                            className="bg-main border border-purple rounded-[20px] transition ease-in-out duration-300 py-1 px-4 text-white hover:border-purple hover:bg-white hover:text-purple font-bold"
                        >
                            Ödəniş et
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default SecondPopupTab;
